export const COURSES_EVENTS = {
  CLOSE_HOMEWORK_VIEWER: 'CLOSE_HOMEWORK_VIEWER',
  CREATE_EDIT_SECTION: 'CREATE_EDIT_SECTION',
  SECTION_OPENED: 'SECTION_OPENED',
  MATERIAL_OPENED: 'MATERIAL_OPENED',
  SECTION_SELECTED: 'SECTION_SELECTED',
  COURSE_SELECTED: 'COURSE_SELECTED',
  EDIT_SECTION: 'EDIT_SECTION',
  REMOVE_SECTION: 'REMOVE_SECTION',
  OBJECT_SELECTED: 'OBJECT_SELECTED',
  EDIT_OBJECT: 'EDIT_OBJECT',
  REMOVE_OBJECT: 'REMOVE_OBJECT',
  ADD_SECTION: 'ADD_SECTION',
  SECTION_CLOSED: 'SECTION_CLOSED',
  LOAD_SECTION_ON_VIEWER: 'LOAD_SECTION_ON_VIEWER',
  LOAD_MATERIAL_ON_VIEWER: 'LOAD_MATERIAL_ON_VIEWER',
  GO_TO_EDIT_SECTION_CONTENT: 'GO_TO_EDIT_SECTION_CONTENT',
  SECTION_REMOVED: 'SECTION_REMOVED',
  SECTION_MOVED: 'SECTION_MOVED',
  SET_OBJECT_FULL_SCREEN: 'SET_OBJECT_FULL_SCREEN',
  LOAD_OBJECT_ON_PREVIEW: 'LOAD_OBJECT_ON_PREVIEW',
  COURSE_WIDGET_RESIZED: 'COURSE_WIDGET_RESIZED',
  SAVE_AND_CLOSE_HOMEWORK: 'SAVE_AND_CLOSE_HOMEWORK',
  COURSE_MATERIAL_REMOVED: 'COURSE_MATERIAL_REMOVED',
  SET_ONLY_VISIBLE_FOR_TEACHER_MATERIAL: 'SET_ONLY_VISIBLE_FOR_TEACHER_MATERIAL',
  RENDER_COMPONENT: 'RENDER_COMPONENT',
  CHECK_IF_FILE_READY: 'CHECK_IF_FILE_READY',
  REFRESH_WIDGET_COURSE: 'REFRESH_WIDGET_COURSE',
  RElOAD_TYPE_OBJECT_EDITORS: 'RElOAD_TYPE_OBJECT_EDITORS',
  REFRESH_ON_SELECT_DUPLICATED_COURSE: 'REFRESH_ON_SELECT_DUPLICATED_COURSE',
  REFRESH_ON_SECTION_UPDATED: 'REFRESH_ON_SECTION_UPDATED',
  KEEP_OPEN_FOLDERS: 'KEEP_OPEN_FOLDERS',
  CLOSE_DRAG_ZONE: 'CLOSE_DRAG_ZONE',
  PROJECT_OPENED: 'PROJECT_OPENED',
  PROJECT_SELECTED: 'PROJECT_SELECTED',
  PROJECT_REMOVED: 'PROJECT_REMOVED',
  UNSELECT_PROJECTS: 'UNSELECT_PROJECTS',
  SUBJECT_DESCRIPTION_BUILDER: 'SUBJECT_DESCRIPTION_BUILDER',
  SUBJECT_FORM_VALID: 'SUBJECT_FORM_VALID',
  SLIDES_FULL_SCREEN: 'SLIDES_FULL_SCREEN',
  OPEN_DECK_EDITOR: 'OPEN_DECK_EDITOR',
  SELECT_CARD: 'SELECT_CARD',
  DECK_CARD_REMOVED: 'DECK_CARD_REMOVED',
  DECK_MOVE_UP: 'DECK_MOVE_UP',
  DECK_MOVE_DOWN: 'DECK_MOVE_DOWN',
  ASSET_CONVERTED: 'ASSET_CONVERTED', 
}